import { Action } from '@ngrx/store';
import { ICommissionState } from '@app/landings/store/model/commission-state.model';

export const COMMISSION_CLICK_SELL_BUTTON = '[Commission page] click on sell button';

export class CommissionClickSellButton implements Action {
  readonly type = COMMISSION_CLICK_SELL_BUTTON;

  constructor(public payload: ICommissionState) {}
}

export type CommissionActions = CommissionClickSellButton;
